import React, { useState, useEffect } from "react";
import './index.scss';
import { AnimatedLetters } from "../../AnimatedLetters";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngular, faHtml5, faCss3, faJsSquare, faReact, faGitAlt, faPython, faAndroid } from '@fortawesome/free-brands-svg-icons'
import Loader from "react-loaders";

export const About = () => {

    const [letterClass, setLetterClass] = useState('text-animate');

    useEffect(() => {
        setTimeout(() => {
            setLetterClass('text-animate-hover');
        }, 4000)
    }, []);

    return (
        <>
            <div className="container about-page">
                <div className="text-zone">
                    <h1>
                        <AnimatedLetters letterClass={letterClass} strArray={'About  me'.split(' ')} idx={15} />
                    </h1>
                    <p>
                        Always open to new things, even those that are not similar to what I do. I'm used to never stop on my laurels and aim only at the strictly best result of my work. It can't be otherwise, can it?)
                    </p>
                    <p>
                        As for hobbies, I have a taste for sports, soccer in particular. In my free time I also like cooking (I watched a lot of Jamie Oliver's shows in my time) Besides that I am an avid film buff and music fan, from movies unfortunately I took a break for the moment but I can't imagine my life without music) Also I can easily support a conversation in a discussion battle Intel vs AMD or Playstation vs Xbox)
                    </p>
                    <p>
                        As for hard skills, I'll highlight 1.5 years of experience in Kotlin, React and Python (in the future also Elixir). During this time I wrote a lot of things on freelance. One of the major projects was the "Optlove" wholesale product marketplace, a project that has been gaining momentum since the end of 2021.
                    </p>
                </div>
                <div className="stage-cube-cont">
                    <div className="cubespinner">
                        <div className="face1">
                            <FontAwesomeIcon icon={faPython} color="#177ee8" />
                        </div>
                        <div className="face2">
                            <FontAwesomeIcon icon={faHtml5} color="#F06529" />
                        </div>
                        <div className="face3">
                            <FontAwesomeIcon icon={faCss3} color="#28A4D9" />
                        </div>
                        <div className="face4">
                            <FontAwesomeIcon icon={faJsSquare} color="#5ED4F4" />
                        </div>
                        <div className="face5">
                            <FontAwesomeIcon icon={faReact} color="#1ecbe1" />
                        </div>
                        <div className="face6">
                            <FontAwesomeIcon icon={faAndroid} color="green" />
                        </div>

                    </div>
                </div>

            </div>
            <Loader type="pacman" />
        </>
    )
}